// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'jquery';
import axios from 'axios';
import Qs from 'qs';
import VueI18n from 'vue-i18n';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueScrollTo from 'vue-scrollto';
// Translations
import en from '@/translations/en.json';
import pl from '@/translations/pl.json';
// API
import Facebook from '@/api/facebook';

// TODO bootstrap should be loaded directly fron node modules, but since it's modified by the author it's not possible
// import 'bootstrap/dist/css/bootstrap.css';
import 'assets/javascripts/bootstrap';
import 'font-awesome/css/font-awesome.css';

import App from './App';
import router from './router';
import Filters from './filters';

// Sentry
Raven
    .config('https://3d32b4c28762473098309366bd1d9809@sentry.applover.pl/5')
    .addPlugin(RavenVue, Vue)
    .install();

Facebook.init();

Vue.use(VueI18n, Filters);
Vue.use(VueScrollTo);


Vue.mixin({
  created() {
    this.$server_url = process.env.SERVER_URL;
  },
});

const messages = {
  en,
  pl,
};

const browserLanguage = window.navigator.userLanguage || window.navigator.language;
let browserLanguageEncoded = '';
if (browserLanguage === 'pl-PL') {
  browserLanguageEncoded = 'pl';
} else {
  browserLanguageEncoded = 'en';
}
const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : browserLanguageEncoded;
localStorage.setItem('lang', lang);

const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
});

Vue.config.productionTip = false;
axios.defaults.baseURL = `${process.env.SERVER_URL}/api/v1/`;
axios.defaults.headers.common['X-User-Email'] = localStorage.getItem('X-User-Email');
axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('X-Auth-Token');
axios.defaults.headers.common['Accept-Language'] = lang;
axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'brackets' });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n,
});



// WEBPACK FOOTER //
// ./src/main.js